exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".olr .mainfe .account .red {\n  color: red; }\n", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/postcss-loader!./~/sass-loader!./src/olr-mainfe-account/styles/index.scss
 ** module id = 205
 ** module chunks = 1
 **/